export const validateMedicareAddress = (
  manualAddress: string,
  manualLocation: string,
  manualCity: string,
  manualCountry: string,
  manualState: string,
  manualZip: string,
  emailId: (string | number)[],
  phoneNumber: (string | number)[],

  faxNumber: (string | number)[]
): string[] => {
  const errors: string[] = [];

  // Validate each address field separately

  if (!manualLocation) {
    errors.push("Please add Manual Location");
  }
  if (!manualAddress) {
    errors.push("Please add Manual Address Line 1");
  }
  if (!manualCity) {
    errors.push("Please add Manual City");
  }
  if (!manualState) {
    errors.push("Please add Manual State");
  }
  if (!manualCountry) {
    errors.push("Please add Manual Country");
  }
  if (!manualZip) {
    errors.push("Please add Manual Zip Code");
  }

  if (emailId) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emailSet = new Set();
    emailId.forEach((email) => {
      const trimmedEmailAddress = email.toString().trim();

      if (!emailRegex.test(trimmedEmailAddress)) {
        errors.push(`Invalid Email Address: ${trimmedEmailAddress}`);
      }

      if (emailSet.has(trimmedEmailAddress)) {
        errors.push(`Duplicate Email Address: ${trimmedEmailAddress}`);
      } else {
        emailSet.add(trimmedEmailAddress);
      }
    });
  }
  if (phoneNumber.length > 0) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    const phoneSet = new Set();
    phoneNumber.forEach((num) => {
      const trimmedPhoneNumber = num.toString().trim();

      if (!phoneRegex.test(trimmedPhoneNumber)) {
        errors.push(`Invalid Phone Number: ${trimmedPhoneNumber}`);
      }

      if (phoneSet.has(trimmedPhoneNumber)) {
        errors.push(`Duplicate Phone Number: ${trimmedPhoneNumber}`);
      } else {
        phoneSet.add(trimmedPhoneNumber);
      }
    });
  }

  // Validate Email Address (at least one required)

  if (faxNumber.length > 0) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;

    const faxSet = new Set();
    faxNumber.forEach((num) => {
      const trimmedFaxNumber = num.toString().trim();

      if (!faxRegex.test(trimmedFaxNumber)) {
        errors.push(`Invalid Fax Number: ${trimmedFaxNumber}`);
      }

      if (faxSet.has(trimmedFaxNumber)) {
        errors.push(`Duplicate Fax Number: ${trimmedFaxNumber}`);
      } else {
        faxSet.add(trimmedFaxNumber);
      }
    });
  }
  return errors;
};
